<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-info m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10">
                <div class="avatar">
                  <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                </div>
              </div>
              <h3 class="h4">Change of Provider</h3>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container">
          <div class="row list">
            <form action="" @submit.prevent="makeRequest">
              <div class="col-lg-12 col-md-12">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="inputCity">Search Enrollee</label>
                        <input type="text" class="form-control" placeholder="Firstn Name, NIN, Phone Number, ID"
                          v-model="searchkey" @change="searchIDCard" />
                        <button class="btn btn-info mt-3" type="button">
                          Search
                        </button>
                      </div>

                      <div class="form-group col-md-12">
                        <label for="inputPassword4">Select Enrollee </label>
                        <!-- <v-select
                        v-model="selected_enrollee"
                        label="user_query"
                        :options="search_result"
                      /> -->

                        <select class="form-control" v-model="enrollee_details" required>
                          <option :value="user" v-for="user in enrollees" :key="user.id">
                            {{ user.user_query }}
                          </option>
                        </select>

                        <p>{{ enrollees.length }} enrollee(s) found</p>
                      </div>

                      <div class="form-group col-md-6" v-if="enrollee_details != ''">
                        <label for="inputCity">Client Surname</label>
                        <input type="text" class="form-control" :value="enrollee_details.lastname" disabled />
                      </div>

                      <div class="form-group col-md-6" v-if="enrollee_details !== ''">
                        <label for="inputCity">Client First Name</label>
                        <input type="text" class="form-control" :value="enrollee_details.firstname" disabled />
                      </div>


                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="inputCity">Reason for Change</label>

                        <p>
                          <button type="button" @click="selectSuggestion(reason)" v-for="reason in reasons"
                            :key="reason" class="btn m-b-15 mx-2 badge badge-soft-info">
                            {{ reason }}
                          </button>
                        </p>

                        <textarea name="" rows="5" class="form-control" v-model="transfer.reason_for_change"
                          required></textarea>
                      </div>

                      <!-- <div class="form-group col-md-12">
                        <input
                          rows="5"
                          cols="80"
                          class="form-control"
                          v-model="search_result.address1"
                          placeholder="Please Enter Your Full Home Address"
                        />
                      </div> -->
                    </div>
                    <div class="row col-md-12" v-if="enrollee_details != ''">
                      <!-- <textarea name="name" rows="8" cols="80" class="form-control" v-model="claim.treatment"></textarea> -->
                      <div class="col-md-12 text-center">
                        <p class="h4">Change of HCP</p>
                      </div>
                      <div class="form-group col-md-6" v-if="enrollee_details.userprovider != null">
                        <label for="inputCity">From Facility</label>
                        <input type="text" class="form-control" :value="enrollee_details.userprovider.agency_name"
                          disabled />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputPassword4">New Facility</label>
                        <v-select v-model="transfer.new_health_facility" :options="providers" label="agency_name"
                          :value="transfer.new_health_facility" @input="selected"></v-select>
                      </div>
                    </div>

                    <div class="col-md-4 offset-md-4">
                      <img :src="`https://claimify-api.hayokmedicare.ng/image/${enrollee_details.user_image}`"
                        class="img spacer-top" alt="User Photo" v-if="
                          enrollee_details != '' &&
                          enrollee_details.user_image != null
                        " onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'" />
                    </div>

                    <div class="fileinput fileinput-new" data-provides="fileinput">
                      <span class="btn btn-info btn-block btn-file">
                        <span class="fileinput-new"><i class="fe fe-upload"></i> Upload Form
                        </span>
                        <span class="fileinput-exists">Change</span>
                        <input type="file" name="..." v-on:change="attachDoc" />
                      </span>
                      <span class="fileinput-filename"></span>
                      <a href="#" class="close fileinput-exists" data-dismiss="fileinput"
                        style="float: none">&times;</a>
                    </div>

                    <div class="form-group">
                      <button class="btn btn-info btn-block" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>

    <div class="vld-parent">
      <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
    </div>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";

  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        agency: agency,
        // settings: JSON.parse(agency.settings),
        user: null,
        enrollees: "",
        reasons: [
          " Change of location",
          " Poor service delivery",
          " Extortion/Over-billing",
          "Facility Disaccreditation",
          "Proximity to new facility",
        ],
        search_result: "",
        enrollee_details: "",
        searchkey: "",
        transfers: "",
        quickref: "",
        document: "",
        card_style: "col-md-12",
        edit: false,
        isLoading: false,
        fullPage: true,
        transfer: {
          reason_for_change: "",
          client_id: "",
          new_health_facility: "",
          previous_health_facility: 0,
          status: "",
          prepared_by: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    computed: {
      //
    },
    methods: {
      selectSuggestion(sug) {
        this.transfer.reason_for_change = sug;
      },
      selected(value) {
        this.transfer.new_health_facility = value;
      },

      clearIt() {
        this.transfer.reason_for_change = "";
        this.transfer.new_health_facility = "";
        this.transfer.previous_health_facility = "";
        this.transfer.status = "";
        this.transfer.prepared_by = "";
        this.searchkey = "";
        this.enrollee_details = "";
      },

      searchIDCard() {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/searchenrollees`, {
            agency_id: 95930,
            request_query: this.searchkey,
          })
          .then((response) => {
            this.enrollees = response.data;

            console.log(response);
            this.$toasted.info("Searched Successfully", {
              position: "top-center",
              duration: 3000,
            });

            this.isLoading = false;
          })
          .catch((error) => {
            this.loading = false;

            console.error(error);
            this.isLoading = false;
            this.$toasted.info("User not Found", {
              position: "top-center",
              duration: 3000,
            });
          });
      },

      getClient() {
        this.isLoading = true;
        this.axios
          .get(`/api/v1/auth/user/${this.claim.client_id}`)
          .then((response) => {
            this.client = response.data.user;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      },

      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgency/${95930}`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      AllTransfers() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/all/change_providers/${95930}`)
          .then((response) => {
            this.transfers = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      makeRequestOld() {
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/change_providers", {
            client_id: this.enrollee_details.id,
            prepared_by: this.user.id,
            agency_id: 95930,
            new_health_facility: this.transfer.new_health_facility.id,
            previous_health_facility: this.enrollee_details.provider_id  == null ? 0 : this.enrollee_details.provider_id,
            phone_number: this.enrollee_details.phone_number,
            address: this.search_result.address,
            status: "created",
            reason_for_change: this.transfer.reason_for_change,
          })

          .then((response) => {
            console.log(response);
            this.AllTransfers();
            this.search_result = "";
            this.enrollee_details = "";
            this.searchkey = "";
            this.transfers = "";
            this.quickref = "";
            this.isLoading = false;
            this.$toasted.info("Request submitted Successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.log(error.response);
          });
      },
      attachDoc(event) {
        this.user = JSON.parse(localStorage.getItem("user"));
        console.log(event);
        this.document = event.target.files[0];
        // this.uploadPicture();
      },
      makeRequest() {
        this.isLoading = true;
        this.user = JSON.parse(localStorage.getItem("user"));
        var formData = new FormData();
        formData.append("claim_document", this.document);
        formData.append("type", "cof");

        //cof details
        formData.append("client_id", this.enrollee_details.id);
        formData.append("prepared_by", this.user.id);
        formData.append("agency_id", 95930);
        formData.append(
          "new_health_facility",
          this.transfer.new_health_facility.id
        );
        formData.append(
          "previous_health_facility",
         this.enrollee_details.provider_id  == null ? 0 : this.enrollee_details.provider_id
        );
        formData.append("status", "created");
        formData.append("reason_for_change", this.transfer.reason_for_change);

        this.axios
          .post("/api/v1/auth/change_providers", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Saved Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.clearIt();
            // this.getSingleClaim();
          })
          .catch((error) => {
            this.$toasted.error("Error Uploading", {
              position: "top-center",
              duration: 3000,
            });
            console.error(error);
            this.isLoading = false;
          });
      },
    },
    created() {
      this.AllTransfers();
      this.getProviders();
    },
  };
</script>

<style scoped>
  .notice {
    padding: 2rem;
    text-align: center;
  }

  .notice__heading {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 500;
  }

  .note__content {
    font-size: 1rem;
  }
</style>